const calcPercentage = (mainValue: number, maxValue: number) => {
  const length = Math.trunc((100 * mainValue) / maxValue)
    .toString()
    .trim();
  return parseFloat(length) > 100 ? "100%" : length + "%";
};

export default calcPercentage;